import { render, staticRenderFns } from "./ProfileFreelancer.vue?vue&type=template&id=94ab5592"
import script from "./ProfileFreelancer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileFreelancer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileFreelancer.vue?vue&type=style&index=0&id=94ab5592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports